import { render } from "./Layout.vue?vue&type=template&id=67f83294&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=67f83294&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67f83294"

export default script